import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EstablishListType } from 'types/kodawari';

/**
 * 設立年数に関するカスタムフック
 * @param initialEstablishList
 * @returns 設立の値と更新する関数を含むオブジェクト
 */
export const useEstablish = (initialEstablishList: EstablishListType[]) => {
  const [establishList, setEstablishList] =
    useState<EstablishListType[]>(initialEstablishList);

  const selectedEstablishList = establishList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedEstablishList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = establishList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setEstablishList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateEstablishListJobCount = (
    establishListJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setEstablishList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(establishListJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedEstablishList = () => {
    const checkedList = establishList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setEstablishList(checkedList);
  };

  return {
    establishList,
    selectedEstablishList,
    updateIsCheckedEstablishList,
    updateEstablishListJobCount,
    clearIsCheckedEstablishList,
  };
};
